export default "__VITE_ASSET__BRr_C0B5__"